import React, { useContext, useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { Link } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import { TancadasApi } from "../api/TancadasApi";
import LoadMask from "../../../../../../../Utils/LoadMask/LoadMask";
import { TancadasTable } from "./TancadasTable";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";
import { TancadasResumen } from "./TancadasResumen";
import { TancadasTotales } from "./TancadasTotales";
import { BultosSkimApi } from "../../../../api/BultosSkimApi";
import { RenderKilogramo } from "../../../../../../../Utils/renderField/renderReadField";
import { ProduccionV2Api } from "../../../../../api/ProduccionV2Api";
import { CorrelativoTancadas } from "../../../../components/CorrelativoTancadas/CorrelativoTancadas";
import {
    CorrelativoTancadasContext,
} from "../../../../../components/BloqueoCorrelativoTancadas/BloqueoCorrelativoTancadas";

export const Listado = ({
    ordenId,
    navigateToCargasTancada,
    regresar,
    modoLectura = false,
}) => {
    const [tancadas, setTancadas] = useState([]);
    const [totales, setTotales] = useState({});
    const [evs, setEvs] = useState({});

    const { getTancadas, crearTancada, deleteTancada, cargando } =
        TancadasApi();

    const { getTotalesBultosSkim } = BultosSkimApi();

    const { cargando: cargandoCompletar } = ProduccionV2Api();

    const correlativo = useContext(CorrelativoTancadasContext);

    const GetTancadas = async () => {
        if (!ordenId) return;

        try {
            const params = {
                orden_id: ordenId,
            };

            const response = await getTancadas(params);
            if (response) {
                setTancadas(response.tancadas || []);
                setTotales(response.totales || {});
                setEvs(response.evs || {});
            }
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las tancadas",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setTancadas([]);
            setEvs({});
        }
    };

    useEffect(() => {
        GetTancadas();
        GetRestanteSkim();
    }, [ordenId]);

    const CrearTancada = async () => {
        if (modoLectura) return;

        try {
            const nuevaTancada = await crearTancada({
                orden_produccion: ordenId,
            });
            NotificationManager.success(
                "Tancada creada correctamente",
                "Éxito",
                3000,
            );

            navigateToCargasTancada(nuevaTancada.id);
        } catch (error) {
            console.log("Error al crear tancada:", error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al crear tancada",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const EliminarTancada = async (id) => {
        if (modoLectura) return;

        try {
            await deleteTancada(id);
            NotificationManager.success(
                "Tancada eliminada correctamente",
                "Éxito",
                3000,
            );
            GetTancadas();
            GetRestanteSkim();
            if (correlativo) correlativo.CargarEstado();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar tancada",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const [restanteSkim, setRestanteSkim] = useState(0);

    const GetRestanteSkim = async () => {
        if (modoLectura) return;

        try {
            const response = await getTotalesBultosSkim();
            setRestanteSkim(response.kg_humedos_restantes);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el restante de skim",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setRestanteSkim(0);
        }
    };

    return (
        <div className="tancadas__tab-wrapper">
            <LoadMask
                loading={
                    cargando ||
                    cargandoCompletar ||
                    Boolean(correlativo && correlativo.cargando)
                }
                blur
            >
                <CardEmpty noShadow>
                    <h4>Tancadas</h4>

                    {!modoLectura && correlativo && (
                        <CorrelativoTancadas hook={correlativo} />
                    )}

                    <TancadasResumen totales={totales} />

                    {evs.numero && (
                        <p className="mb-3" style={{ marginTop: "-0.5rem" }}>
                            <strong>EVS:</strong> {evs.numero} ·{" "}
                            <strong>Producto:</strong> {evs.producto_a_producir}
                        </p>
                    )}

                    <TancadasTable
                        tancadas={tancadas}
                        EliminarTancada={EliminarTancada}
                        modoLectura={modoLectura}
                    />

                    <TancadasTotales totales={totales} />

                    {!modoLectura && (
                        <div className="d-flex justify-content-between mt-4 mb-3 pt-1 gap-1rem">
                            <Link to={`/produccion-v2/bultos-skim`}>
                                <button className="btn btn-outline-dark">
                                    Preparación de Skim (
                                    <RenderKilogramo
                                        value={restanteSkim}
                                        decimals={3}
                                    />
                                    )
                                </button>
                            </Link>
                            <div className="d-flex gap-1rem">
                                <button
                                    className="btn btn-primary"
                                    onClick={CrearTancada}
                                >
                                    Agregar tancada
                                </button>
                            </div>
                        </div>
                    )}
                    <div className="d-flex justify-content-center mt-3 mb-3">
                        <button
                            className="btn btn-outline-dark"
                            onClick={regresar}
                        >
                            Regresar
                        </button>
                    </div>
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
